import { env } from '@/data/env';

export interface AuthParams {
	searchParams: Promise<{ next?: string }> | { next?: string };
}

const getAllowedRedirectOrigins = () =>
	[env.NEXT_PUBLIC_ORIGIN_WWW, env.NEXT_PUBLIC_ORIGIN_RUN].map((origin) => new URL(origin).origin);

export function isAllowedRedirectUrl(value: string) {
	try {
		const url =
			value.startsWith('/') && !value.startsWith('//') ? new URL(value, env.NEXT_PUBLIC_ORIGIN_RUN) : new URL(value);

		return getAllowedRedirectOrigins().includes(url.origin);
	} catch {
		return false;
	}
}

function getSafeNextUrl(value: string | null | undefined) {
	if (!(value && isAllowedRedirectUrl(value))) {
		return;
	}

	return value.startsWith('/') && !value.startsWith('//') ? value : new URL(value).toString();
}

export async function getNextUrl(params: AuthParams) {
	let next: string | undefined;

	if (typeof window === 'undefined') {
		const searchParams = await (typeof params.searchParams === 'object' && 'then' in params.searchParams
			? params.searchParams
			: Promise.resolve(params.searchParams));

		next = getSafeNextUrl(searchParams.next);
	} else {
		const url = new URL(window.location.href);
		next = getSafeNextUrl(url.searchParams.get('next'));
	}

	if (typeof window !== 'undefined' && next) {
		window.sessionStorage.setItem('__next__', next);
	}

	return next ?? env.NEXT_PUBLIC_ORIGIN_RUN;
}
